// Whether a CSS media query matches now, following changes. For layout that
// CSS alone cannot decide, such as how many boards fit on the bar (TOM-192).

import { useEffect, useState } from 'react';

/** The bar's widths (web-refresh-v2.md "Layout by width"). */
export const PHONE_QUERY = '(max-width: 768px)';
export const BAR_QUERY = '(max-width: 1024px)';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );
  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
